import React from 'react';
import Container from 'container';
import Headline from 'headline';

import s from './banner-title.module.scss';

export default function Banner({
  children,
  title,
  center,
  custom,
  slim,
  className,
  ...props
}) {
  return (
    <Container
      className={`${s.banner} ${slim ? s.slim : ''} ${className || ''}`}
      data-placement={props.placement}
    >
      {custom ? (
        children || title
      ) : (
        <Headline h3 el="h1" className={s.headline} white center={center}>
          {children || title}
        </Headline>
      )}
    </Container>
  );
}
